import * as React from "react";
import { cn } from "../../lib/utils";
const Alert = React.forwardRef(({ className, variant, ...props }, ref) => {
    const variantClass = variant === "destructive" ? "va-alert--destructive" : "";
    return (<div ref={ref} role="alert" className={cn("va-alert", variantClass, className)} {...props}/>);
});
Alert.displayName = "Alert";
const AlertTitle = React.forwardRef(({ className, ...props }, ref) => (<h5 ref={ref} className={cn("va-card-title", className)} {...props}/>));
AlertTitle.displayName = "AlertTitle";
const AlertDescription = React.forwardRef(({ className, ...props }, ref) => (<div ref={ref} className={cn("va-card-description", className)} {...props}/>));
AlertDescription.displayName = "AlertDescription";
export { Alert, AlertTitle, AlertDescription };
